import type { ElevationProfile } from '../../shared/elevation';
import { buildElevationProfile } from '../../shared/elevation';
import type { Ping } from '../../shared/wire';
import { state } from '../state/app-state';
import { getShareViewerPings } from '../state/app-state';
import { MOCK } from '../state/device';
import { replay } from '../state/replay';

let elevationPanelEl: HTMLElement | null = null;
export function ensureElevationPanel(): HTMLElement {
  if(elevationPanelEl) return elevationPanelEl;
  const el = document.createElement('div');
  el.className = 'elev-panel';
  el.id = 'elev-panel';
  (el as any).hidden = true;
  (document.querySelector('.map-body') || document.body).appendChild(el);
  elevationPanelEl = el;
  return el;
}
export function elevSparkline(prof: ElevationProfile): string {
  const s = prof.samples;
  if(s.length < 2) return '';
  const W = 168, H = 34, pad = 3;
  const span = (prof.max - prof.min) || 1;
  const t0 = s[0].t, tspan = (s[s.length-1].t - t0) || 1;
  const pts = s.map(p => {
    const x = pad + ((p.t - t0) / tspan) * (W - 2*pad);
    const y = pad + (1 - (p.altitude_meters - prof.min) / span) * (H - 2*pad);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  return `<svg class="elev-spark" viewBox="0 0 ${W} ${H}" preserveAspectRatio="none" aria-hidden="true"><polyline points="${pts}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"/></svg>`;
}

// Which pings the scrubber currently governs, or null when replay doesn't
// apply (cohort 'devices' mode has no single timeline).
export function replaySourcePings(): Ping[] | null {
  if(document.body.dataset.mode === 'share-viewer') return getShareViewerPings();
  if(state.viewMode === 'devices') return null;
  return MOCK.pings;
}

export function updateElevationPanel(){
  const el = ensureElevationPanel();
  const pings = replaySourcePings();
  const prof = pings ? buildElevationProfile(pings) : null;
  if(!prof){ (el as any).hidden = true; return; }
  const r = (n: number) => Math.round(n);
  // Vertical accuracy is the honest-precision caveat: altitude is the
  // least reliable GPS axis, so we surface its mean accuracy beside the
  // numbers rather than implying the climb total is exact.
  const acc = prof.meanAccuracy != null ? `±${r(prof.meanAccuracy)} m` : 'accuracy n/a';
  el.innerHTML =
    `<div class="elev-head"><i class="ph ph-mountains" aria-hidden="true"></i> Elevation`
    + ` <span class="elev-acc" title="mean vertical accuracy">${acc}</span></div>`
    + `<div class="elev-stats"><span class="elev-up">▲ ${r(prof.gain)} m</span>`
    + `<span class="elev-dn">▼ ${r(prof.loss)} m</span>`
    + `<span class="elev-rng">${r(prof.min)}–${r(prof.max)} m</span></div>`
    + elevSparkline(prof);
  (el as any).hidden = false;
}

// The clip applied by both render paths. No-op at the live edge / inactive.
export function replayClip(pings: Ping[]): Ping[] {
  if(replay.cutoffT === Infinity) return pings;
  return pings.filter(p => p.t <= replay.cutoffT);
}
